import {createSlice} from "@reduxjs/toolkit";
import {toast} from "react-toastify";

const slice = createSlice({
    name: 'vendor-orders',
    initialState: {
        byId: {},
        loading: false,
        error: null
    },
    reducers: {
        startLoading: (state) => {
            state.error = null;
            state.loading = true;
        },
        hasError: (state, action) => {
            state.error = action.payload;
            state.loading = false;
            console.error(action.payload);
            toast.error("Une erreur s'est produite - vendor-orders")
        },
        gotItem: (state, action) => {
            state.error = null;
            state.loading = false;
            state.byId[action.payload?.id] = action.payload;
        }
    }
})

export const {startLoading, hasError, gotItem} = slice.actions;

const vendorOrdersReducer = slice.reducer;

export default vendorOrdersReducer;